import constants from '@/constants';
import store from '@/store';
import i18n from '@/configured/vue-i18n';
import user from '@/components/user';
import products from '@/components/products';
import api, {localizedAndRegionalUrl, craftError} from '@/api';
import offline from '@/offline';
import Fuse from 'fuse.js';
import log from '@/configured/logger';

const exports = {
  namespace: 'search',
  module: {
    namespaced: true,
    state: {
      query: '',
      request: null,
      errorCode: false,
      results: [],
    },
    mutations: {
      START_QUERY: (state, {query, request}) => {
        state.query     = query;
        state.request   = request;
        state.errorCode = false;
      },
      SET_RESULTS: (state, results) => {
        state.errorCode = false;
        state.request   = null;
        state.results   = results;
      },
      SET_ERROR: (state, errorCode) => {
        state.request   = null;
        state.errorCode = errorCode;
        state.results   = [];
      },
      CANCEL_REQUEST: (state) => {
        state.query     = '';
        state.request   = null;
        state.errorCode = false;
        state.results   = [];
      }
    },
    actions: {
      sendQuery,
      cancelQuery,
    }
  }
};

store.registerModule(exports.namespace.split('/'), exports.module);
export default exports;

//////////

function sendQuery({state, commit}, query) {
  if (query.length === 0) {
    return commit('CANCEL_REQUEST');
  }

  const request = api.CancelToken.source();

  // Initialize the search
  commit('START_QUERY', {query, request});

  const isOnline = store.state[offline.store.namespace].isOnline;
  const search = isOnline ? queryOnline : queryOffline;

  search(query, request)
  .then(rsp => {
    if (!craftError(rsp), (error) => commit('SET_ERROR', constants.ERROR.SEARCHING)) {
      commit('SET_RESULTS', rsp.data);
    }
  })
  .catch(thrown => {
    if (api.isCancel(thrown)) {
      commit('CANCEL_REQUEST');
      log.info("Search canceled", thrown);
    } else {
      commit('SET_ERROR', constants.ERROR.SEARCHING);
      log.error("Error searching", thrown);
    }
  });
}

function queryOnline(query, request) {
  const url = localizedAndRegionalUrl(`/search/${encodeURIComponent(query)}`);
  return api.get(url, {cancelToken: request.token})
}

function queryOffline(query, request) {
  return new Promise((resolve, reject) => {
    const options = {
      shouldSort: true,
      threshold: 0.2,
      keys: [
        'title',
        'tagLine',
        'overview',
        'features.body',
        'specifications.title',
        'specifications.customSpecifications.value',
        'mediaCollections.media.title',
      ],
    };
    const fuse = new Fuse(store.state[products.store.namespace].products, options);
    resolve({data: fuse.search(query)});
  });
}

function cancelQuery({state, commit}) {
  if (state.request) {
    state.request.cancel('Canceled query');
  } else {
    commit('CANCEL_REQUEST');
  }
}
